// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"artist-module--submitButton--2_kwL","homeLink":"artist-module--homeLink--20-fw"};